"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var http_debugger_1 = require("./http.debugger");
function getCallback(call, options, callback) {
    http_debugger_1.httpDebugger.debugStartHttpRequest();
    var axiosPromise = axios_1.default.get(call.url, {
        headers: getHeadersJson(options && options.headers ? options.headers : [])
    });
    axiosPromise.then(function (response) {
        http_debugger_1.httpDebugger.debugResolveHttpRequest();
        callback({
            response: response
        });
    }, function (error) {
        http_debugger_1.httpDebugger.debugFailedHttpRequest();
        callback({
            error: error
        });
    });
}
exports.getCallback = getCallback;
function putCallback(call, options, callback) {
    http_debugger_1.httpDebugger.debugStartHttpRequest();
    var axiosPromise = axios_1.default.put(call.url, call.body, {
        headers: getHeadersJson(options && options.headers ? options.headers : [])
    });
    axiosPromise.then(function (response) {
        http_debugger_1.httpDebugger.debugResolveHttpRequest();
        callback({
            response: response
        });
    }, function (error) {
        http_debugger_1.httpDebugger.debugFailedHttpRequest();
        callback({
            error: error
        });
    });
}
exports.putCallback = putCallback;
function deleteCallback(call, options, callback) {
    http_debugger_1.httpDebugger.debugStartHttpRequest();
    var axiosPromise = axios_1.default.delete(call.url, {
        headers: getHeadersJson(options && options.headers ? options.headers : [])
    });
    axiosPromise.then(function (response) {
        http_debugger_1.httpDebugger.debugResolveHttpRequest();
        callback({
            response: response
        });
    }, function (error) {
        http_debugger_1.httpDebugger.debugFailedHttpRequest();
        callback({
            error: error
        });
    });
}
exports.deleteCallback = deleteCallback;
function postCallback(call, options, callback) {
    http_debugger_1.httpDebugger.debugStartHttpRequest();
    var axiosPromise = axios_1.default.post(call.url, call.body, {
        headers: getHeadersJson(options && options.headers ? options.headers : [])
    });
    axiosPromise.then(function (response) {
        http_debugger_1.httpDebugger.debugResolveHttpRequest();
        callback({
            response: response
        });
    }, function (error) {
        http_debugger_1.httpDebugger.debugFailedHttpRequest();
        callback({
            error: error
        });
    });
}
exports.postCallback = postCallback;
function getHeadersJson(headers) {
    var headerJson = {};
    headers.forEach(function (header) {
        headerJson[header.header] = header.value;
    });
    // add default content type header if not present
    var contentTypeHeader = headers.find(function (m) { return m.header.toLowerCase() === 'Content-Type'.toLowerCase(); });
    if (!contentTypeHeader) {
        headerJson['Content-Type'] = 'application/json';
    }
    return headerJson;
}
exports.getHeadersJson = getHeadersJson;
//# sourceMappingURL=http.functions.js.map